import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import "./SinglePost.css"; // You'll create this CSS file

const SinglePost = () => {
  const { id } = useParams(); // Get the post ID from the URL
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/posts/${id}`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setPost(data);
        // Track post view here, after successful fetch
        const user = JSON.parse(localStorage.getItem("user"));
        let sessionId = localStorage.getItem("sessionId");
        if (!sessionId) {
          sessionId =
            (crypto.randomUUID && crypto.randomUUID()) ||
            Math.random().toString(36).substring(2);
          localStorage.setItem("sessionId", sessionId);
        }
        fetch(`${process.env.REACT_APP_API_URL}/analytics/track-post-view`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            postId: id,
            userId: user?.userId || null,
          }),
        });
      } catch (err) {
        setError("Failed to fetch post. Please try again later.");
        console.error("Error fetching single post:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [id]); // Re-run effect if ID changes

  if (loading) {
    return <div className="single-post-container">Loading post...</div>;
  }

  if (error) {
    return <div className="single-post-container error">{error}</div>;
  }

  if (!post) {
    return (
      <div className="single-post-container">No post found with this ID.</div>
    );
  }

  const cleanHTML = DOMPurify.sanitize(post.content);

  return (
    <div className="single-post-container">
      <h1 data-tts="true" className="single-post-title">
        {post.title}
      </h1>
      <p data-tts="true" className="single-post-subtitle">
        {post.subtitle}
      </p>
      <div className="single-post-meta">
        <span data-tts="true">By: {post.username}</span> |{" "}
        <span data-tts="true">Category: {post.category}</span>
      </div>
      {post.imageUrls && post.imageUrls.length > 0 && (
        <div className="single-post-images">
          {post.imageUrls.map((imageUrl, index) => (
            <img
              key={index}
              src={imageUrl}
              alt={`${post.title} image ${index + 1}`}
              className="single-post-image"
            />
          ))}
        </div>
      )}

      <div
        data-tts="true"
        className="single-post-content"
        dangerouslySetInnerHTML={{ __html: cleanHTML }}
      />
      {/* You can add a download link here if 'post.link' is for download */}
      {post.link && (
        <div className="single-post-actions">
          <a
            href={post.link}
            target="_blank"
            rel="noopener noreferrer"
            className="single-post-download-button"
          >
            Download Original Document
          </a>
        </div>
      )}
      {post.pdfUrls && post.pdfUrls.length > 0 && (
        <div className="single-post-pdfs">
          {post.pdfUrls.map((pdfUrl, idx) => (
            <div key={idx} style={{ marginBottom: "1rem" }}>
              <embed
                src={pdfUrl}
                type="application/pdf"
                width="100%"
                height="600px"
              />
              <a
                href={pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="single-post-download-button"
              >
                Download PDF
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SinglePost;
